// extracted by mini-css-extract-plugin
export default {"background":"contact_background__Q6mMm","listColor":"contact_listColor__5R68q","smallerTextAndItalic":"contact_smallerTextAndItalic__zld8k"};